import React from 'react';
import { TagIcon } from 'lucide-react';
export function Specials() {
  const specials = [{
    title: 'First Responders',
    discount: '15% OFF',
    desc: 'Thank you for your service. Valid on all towing and roadside assistance.'
  }, {
    title: 'AAA Members',
    discount: '10% OFF',
    desc: 'Show your active AAA card for an instant discount on out-of-pocket costs.'
  }, {
    title: 'Student Discount',
    discount: '$20 OFF',
    desc: 'Valid college ID required. Applicable for jumpstarts and lockouts.'
  }];
  return <section id="specials" className="py-20 bg-accent" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <div className="text-center mb-16" data-id="element-278">
          <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-4" data-id="element-279">
            Specials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary" data-id="element-280">
            Current Offers
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-281">
          {specials.map((special, idx) => <div key={idx} className="bg-white rounded-[10px] p-8 shadow-sm border border-gray-100 relative overflow-hidden group hover:border-primary transition-colors" data-id="element-282">
              <div className="absolute top-0 right-0 bg-primary text-white p-3 rounded-bl-[10px]" data-id="element-283">
                <TagIcon className="w-6 h-6" data-id="element-284" />
              </div>
              <h3 className="text-xl font-bold text-secondary mb-2 mt-4" data-id="element-285">
                {special.title}
              </h3>
              <div className="text-4xl font-black text-primary mb-4" data-id="element-286">
                {special.discount}
              </div>
              <p className="text-gray-600" data-id="element-287">{special.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}